import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ConfirmDialogProvider } from "@/components/ConfirmDialog";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Forgot from "@/pages/Forgot";
import Profile from "@/pages/Profile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Paywall from "@/pages/Paywall";
import Dashboard from "@/pages/Dashboard";
import NewObituary from "@/pages/NewObituary";
import ViewObituary from "@/pages/ViewObituary";
import Templates from "@/pages/Templates";
import EmailPhotos from "@/pages/EmailPhotos";
import OwnerDashboard from "@/pages/OwnerDashboard";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/LegalPages";
import MusicPlayer from "@/components/MusicPlayer";
import Team from "@/pages/Team";
import AcceptInvite from "@/pages/AcceptInvite";
import MemorialPage from "@/pages/MemorialPage";
import GriefSupport from "@/pages/GriefSupport";
import GiftView from "@/pages/GiftView";
import GiftSent from "@/pages/GiftSent";
import TributeVideo from "@/pages/TributeVideo";
import Poem from "@/pages/Poem";
import PoemPending from "@/pages/PoemPending";
import BundleSuccess from "@/pages/BundleSuccess";

function Layout({ children }) {
  return (
    <div className="App">
      <Header />
      <main style={{ minHeight: "70vh" }}>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ConfirmDialogProvider>
        <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/email-photos" element={<ProtectedRoute requireSub><EmailPhotos /></ProtectedRoute>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/grief-support" element={<GriefSupport />} />
            <Route path="/m/:slug" element={<MemorialPage />} />
            <Route path="/gift/:token" element={<GiftView />} />
            <Route path="/gift-sent" element={<ProtectedRoute><GiftSent /></ProtectedRoute>} />
            <Route path="/team/accept" element={<AcceptInvite />} />
            <Route path="/paywall" element={<ProtectedRoute><Paywall /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            <Route path="/new" element={<ProtectedRoute requireSub><NewObituary /></ProtectedRoute>} />
            <Route path="/obituary/:id" element={<ProtectedRoute><ViewObituary /></ProtectedRoute>} />
            <Route path="/tribute-video" element={<ProtectedRoute><TributeVideo /></ProtectedRoute>} />
            <Route path="/poem/pending" element={<ProtectedRoute><PoemPending /></ProtectedRoute>} />
            <Route path="/poem/:poem_id" element={<ProtectedRoute><Poem /></ProtectedRoute>} />
            <Route path="/bundle/success" element={<ProtectedRoute><BundleSuccess /></ProtectedRoute>} />
            <Route path="/owner" element={<ProtectedRoute ownerOnly><OwnerDashboard /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors theme="dark" />
        <MusicPlayer />
      </BrowserRouter>
      </ConfirmDialogProvider>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: 100 }}>
      <div className="serif" style={{ fontSize: 60, color: "var(--gold)" }}>404</div>
      <div className="muted">This page does not exist.</div>
    </div>
  );
}

export default App;
